import classNames from "lib/classNames";
import { useCallback, useMemo } from "react";
import { useLayerCake } from "./LayerCake";


type TickFunction = (any) => any;
interface XAxisProps {
  ticks?: number[] | TickFunction;
  className?: string;
  gridlines?: boolean;
  tickMarks?: boolean;
  baseline?: boolean;
  snapTicks?: boolean;
  formatTick?: (d: any) => any;
}


export default function AxisX({
  ticks,
  gridlines = false,
  tickMarks = false,
  baseline = false,
  snapTicks = false,
  className="",
  formatTick = (d) => d,
}: XAxisProps) {

  const { height, width, domainScale, padding } = useLayerCake();

  const tickVals = useMemo(() => {
    return Array.isArray(ticks)
      ? ticks
      : typeof ticks === "function"
      ? ticks(domainScale.ticks())
      : domainScale.ticks(ticks);
  }, [ticks]);

  const textAnchor = useCallback((i) => {
		if (snapTicks === true) {
			if (i === 0) {
				return "start";
			}
			if (i === tickVals.length - 1) {
				return "end";
			}
		}
		return "middle";
	}, [snapTicks, tickVals]);

  return (
    <g className={classNames(
        "axis x-axis",
        className
      )}
      transform={`translate(${padding.left},${padding.top})`}
    >
      {tickVals.map((tick, i) => (
        <g
          key={`tick-${i}`}
          className="text-sm font-light"
          transform={`translate(${domainScale(tick)},0)`}
        >
          {gridlines !== false && (
            <line stroke="currentColor" strokeWidth="1" strokeDasharray="2 4" className="gridline text-gray-200 dark:text-gray-600" y1={height * -1} y2="0" x1="0" x2="0" />
          )}
          {tickMarks === true && (
            <line stroke="currentColor" strokeWidth="1" className="tick-mark text-gray-200 dark:text-gray-600" y1={height-padding.bottom-padding.top} y2={height-padding.bottom-padding.top+12} x1={0} x2={0} />
          )}
          <text x={0} y={height - padding.top} dx="" dy="" textAnchor={textAnchor(i)}
            className={classNames(
              "fill-gray-700 dark:fill-gray-200 relative whitespace-nowrap",
              i === 0 ? "" : "",
              i === tickVals.length-1 ? "" : ""
            )}
          >{formatTick(tick)}</text>
        </g>
      ))}
      {baseline === true && (
        <line
          className="baseline absolute text-gray-300 dark:text-gray-600"
          strokeWidth="1"
          stroke="currentColor"
          y1={height - padding.top - padding.bottom}
          y2={height - padding.top - padding.bottom}
          x1={padding.left}
          x2={width-padding.left-padding.right}
        />
      )}
    </g>
  );
}
